import { useTranslate } from "@opensea/next-translate"
import { VpnKey } from "@opensea/ui-kit/icons"
import { usePrivy } from "@privy-io/react-auth"
import React from "react"
import { useTrackingFn } from "@/lib/analytics/useTrackingFn"
import { SettingsItem } from "./SettingsItem.react"

export function ExportPrivateKeyItem() {
  const t = useTranslate("settings")

  const trackExportWallet = useTrackingFn("export wallet")
  const { exportWallet } = usePrivy()

  const handleExportWallet = async () => {
    trackExportWallet()
    await exportWallet()
  }

  return (
    <SettingsItem
      icon={<VpnKey />}
      label={t("settingsPage.exportKey", "Export private key")}
      onClick={handleExportWallet}
    />
  )
}
